import React from "react";

export default function ThankYou() {
  return (
  <div className="thankyou-container">
  <h1>Thank You!</h1>
  <p>Your message has been received. We will get back to you shortly.</p>
  <a href="/" className="button">Go to Home</a>
</div>

  );
}
